import { FC } from 'react';
import { DescriptionList } from '@doda/io-react/common';
import { FeaturedJobsDisplay } from '@doda/common/src/logics/newJobList/convertFeaturedJobsDisplayData';
import styles from './index.module.scss';

/** PickUpJobList */
interface Props {
  /** 注目求人リスト*/
  featuredJobList: FeaturedJobsDisplay[];
}

/**
 * 新着求人一覧画面 注目求人リスト
 */
export const PickUpJobList: FC<Props> = ({ featuredJobList }) => {
  const listData = featuredJobList.map((data) => {
    // 会社ごとの注目求人リスト
    const contents = data.jobLinkList.map(({ url, text }, index) => (
      <li key={index}>
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          className={styles.pickUpJobList__link}
        >
          {text}
        </a>
      </li>
    ));
    return {
      title: data.companyName,
      contents,
    };
  });
  return (
    <DescriptionList
      type="column2"
      column2dataBgColor="white"
      className={styles.featuredJobList}
      listData={listData}
    />
  );
};
